import { render, staticRenderFns } from "./KeyAccountShops.vue?vue&type=template&id=04dc63b4&scoped=true&"
import script from "./KeyAccountShops.vue?vue&type=script&lang=js&"
export * from "./KeyAccountShops.vue?vue&type=script&lang=js&"
import style0 from "./KeyAccountShops.vue?vue&type=style&index=0&id=04dc63b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dc63b4",
  null
  
)

export default component.exports